import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';
import {
  Auth, SatCoreComponent, accommodationsManager, appManager, assignmentManager,
  classroomManager, contentManager, courseDeliveryManager, courseManager,
  dialogManager, gradebookManager, i18nAddSatellite, navigationManager, userManager
} from 'sat-core';
import * as serviceWorker from './serviceWorker';

import { API_ROOT, LESSON_ROOT, PUBLISHER_ROOT, PUBLISHER_SATELLITE_CODE } from './api-config';

import logo from './img/goodheart-willcox-logo.png';
import 'semantic-ui-less/semantic.less';
import './index.less';

/* Put override imports here */
import './components/CourseListBannerOverride';
import './components/FeedbackIconOverride';
import './views/LoginOverride';
import './views/MainViewOverride';
import './views/ProgressViewOverride';
import './services/GwBannerServiceOverride';
import './services/AccommodationsServiceOverride';

import gwTranslations from './gwTranslations';

i18nAddSatellite('gw', gwTranslations);

const App = SatCoreComponent('App');
Auth.init(API_ROOT, PUBLISHER_ROOT, PUBLISHER_SATELLITE_CODE, logo, LESSON_ROOT);
// accommodationsManager.setIncludeAssignmentAccommodations(true);
accommodationsManager.setIncludeClassroomAccommodations(true);
appManager.init({ classWorkspaceFeature: true, trialFeature: true });
appManager.setShouldReloadLoginPageAfterLogout(true);
assignmentManager.setEnableCourseSearch(true);
assignmentManager.setIncludeAlignments(true);
classroomManager.setEnabledStudentsOnly(false);
contentManager.setResourceIFrameUrl('https://support.g-w.com/kb/section/112');
contentManager.setResourceIFrameUrlStudent('https://support.g-w.com/kb/section/114');
courseDeliveryManager.setAllowedResourcePillKeys(['manualScored', 'autoScored']);
courseManager.setAllowClassroomCourseCardDragDropReorder(true);
courseManager.setIncludeAlignments(true);
dialogManager.setUseWhiteInfoIcon(true);
gradebookManager.setShouldHideUnscorableColumns(true);
navigationManager.setAllowCarouselAdaptiveHeight(true);
userManager.setClientPrefix('GW');

ReactDOM.render(
  <Provider
    assignmentManager={assignmentManager}
    classroomManager={classroomManager}
    contentManager={contentManager}
    courseManager={courseManager}
    dialogManager={dialogManager}
    gradeBookManager={gradebookManager}
    navigationManager={navigationManager}
    userManager={userManager}>
    <App />
  </Provider>, document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
